"use client"

import { useRef } from "react"
import { motion, useInView } from "framer-motion"

export default function ScrollText({ text, className }) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: false, margin: "-20%" })

  return (
    <div ref={ref} className={className}>
      {text.split("").map((char, index) => (
        <motion.span
          key={index}
          initial={{ opacity: 0.3 }}
          animate={{
            opacity: isInView ? 1 : 0.3,
            color: isInView ? "currentColor" : "#999999",
          }}
          transition={{
            duration: 0.3,
            delay: isInView ? index * 0.02 : 0,
          }}
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
    </div>
  )
}
